import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { label: '婚后角色转变', to: '/category/role-transition' },
        { label: '夫妻相处技巧', to: '/category/couple-skills' },
        { label: '婚姻经营秘诀', to: '/category/marriage-secrets' },
        { label: '新婚适应期攻略', to: '/category/newlywed-guide' },
        { label: '家庭经营之道', to: '/category/family-management' },
        { label: '自我成长', to: '/category/self-growth' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系方式', to: '/about#contact' },
        { label: '用户口碑', to: '/about#testimonials' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            <div className="lg:col-span-2">
              <Link to="/" className="text-xl font-heading font-semibold text-foreground-900">
                第一次的人妻
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-sm">
                专为初为人妻的女性打造的温暖生活指南，涵盖婚后角色转变、夫妻沟通、婚姻经营与自我成长，陪伴每一位新婚妻子从容迎接幸福新生活。
              </p>
            </div>

            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-800 mb-4">{section.title}</h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 第一次的人妻. 保留所有权利.
            </p>
            <div className="flex items-center gap-5">
              <a
                href="#"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
                rel="nofollow"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
                rel="nofollow"
              >
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}